import { Log, useUBL } from '@common/log-manager';

import { ShopUxUbl } from '../types';

interface ChipAndSortingFilterUBLProps {
  log: Partial<Log> & { navigation: string };
}

export const useChipAndSortingFilterUBL = ({ log }: ChipAndSortingFilterUBLProps) => {
  const tracker = useUBL();

  const clickSortingFilterUBL = (ubl?: ShopUxUbl | null) => {
    tracker({
      ...log,
      category: 'click',
      object_type: ubl?.object?.type ?? 'sort',
      object_id: ubl?.object?.id ? String(ubl.object.id) : '',
      data: ubl?.server_log ?? null,
    });
  };

  const clickGridViewUBL = (ubl?: ShopUxUbl | null) => {
    tracker({
      ...log,
      category: 'click',
      object_type: ubl?.object?.type ?? 'button',
      object_id: ubl?.object?.id ? String(ubl.object.id) : '',
      data: ubl?.server_log ?? null,
    });
  };

  const clickFilterChipUBL = (ubl?: ShopUxUbl | null) => {
    tracker({
      ...log,
      category: 'click',
      object_type: ubl?.object?.type ?? 'filter',
      object_id: ubl?.object?.id ? String(ubl.object.id) : '',
      data: ubl?.server_log ?? null,
    });
  };

  return {
    clickSortingFilterUBL,
    clickGridViewUBL,
    clickFilterChipUBL,
  };
};
